module.exports = __webpack_public_path__ + "static/media/slide-stucco.b14d87d3.jpg";